export default __webpack_public_path__ + "img/f76c76b456340bb059fb596b1f13da0c.svg";